import GenericSelector from '../../../../../../../components/global/GenericSelector/GenericSelector';
import React, { useCallback } from 'react';
import { useAppDispatch } from '../../../../../../../store';
import { PayloadAction } from '@reduxjs/toolkit';

interface RedistributionGenericMultiSelectorFilterOptionsProps {
  label: string;
  options: { id: number; label: string }[];
  value: number[];
  dispatcher: (value: number[]) => PayloadAction<number[]>;
  loading?: boolean;
}

/**
 * Generic multi-selector to be used as redistribution filter.
 * Dispatches the selected array of ids to the store.
 * @param label Label of the selector
 * @param options options to use
 * @param value currently selected ids
 * @param dispatcher action creator producing the store update for the selection
 * @param loading show a loading indicator
 */
const RedistributionGenericMultiSelectorFilter: React.FC<
  RedistributionGenericMultiSelectorFilterOptionsProps
> = ({ label, options, value, dispatcher, loading }) => {
  const dispatch = useAppDispatch();

  const onItemsSelected = useCallback(
    (itemIds: number[]) => {
      dispatch(dispatcher(itemIds));
    },
    [dispatch, dispatcher],
  );

  return (
    <GenericSelector
      multiple
      options={options}
      label={label}
      value={value}
      onChange={onItemsSelected}
      loading={loading}
      showSearch
    />
  );
};

export default RedistributionGenericMultiSelectorFilter;
